import axios from 'axios'
import { portalAuthHttpClient } from '../utils/HttpRequestUtils'
import envConfigs from '../configs/envConfigs'

export const getSaveTemplateResponse = async (data) => {
	const url = `${envConfigs.baseUrl}${envConfigs.saveTemplateUrl}`
	const response = await portalAuthHttpClient.post(url, data)
	return response.data
}
